/* import __COLOCATED_TEMPLATE__ from './recommend-checking.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { Action, Applet, Feature, getEvent, Page, Target } from '@banking/ui/utils/checking/event-catalog';
import { getCheckingUpsellImage } from '@banking/ui/utils/checking-image-urls';
let RecommendChecking = (_class = class RecommendChecking extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "assetMap", _descriptor2, this);
    _initializerDefineProperty(this, "events", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "businessName", _descriptor5, this);
  }
  get imageSrc() {
    const countryCode = this.userInfo.countryCode;
    return this.assetMap.resolve(getCheckingUpsellImage(countryCode));
  }
  _getAndTrackCdpEvent(additionalProperties) {
    const cdpEvent = getEvent({
      action: Action.Click,
      feature: Feature.RecommendChecking
    });
    this.events.track({
      kind: 'CDP',
      event: {
        name: cdpEvent.name,
        properties: {
          ...cdpEvent.properties,
          ...additionalProperties
        }
      }
    });
  }
  _trackGoToChecking() {
    this._getAndTrackCdpEvent({
      applet: Applet.Settings,
      page: Page.Overview,
      target: Target.CheckingOnboarding
    });
  }
  _trackDismissBanner() {
    this._getAndTrackCdpEvent({
      applet: Applet.Settings,
      page: Page.Overview,
      target: Target.DismissBanner
    });
  }
  dismissRecommendChecking() {
    this.args.dismissRecommendChecking();
    this._trackDismissBanner();
  }
  goToChecking() {
    this._trackGoToChecking();
    this.applicationRouter.transitionTo('checking');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "businessName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.unitAccounts.length > 0 ? this.args.unitAccounts[0].name || '' : '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "dismissRecommendChecking", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissRecommendChecking"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToChecking", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToChecking"), _class.prototype), _class);
export { RecommendChecking as default };